import { render, staticRenderFns } from "./PreliminaryReviewDialog.vue?vue&type=template&id=871898a4&scoped=true"
import script from "./PreliminaryReviewDialog.vue?vue&type=script&lang=js"
export * from "./PreliminaryReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PreliminaryReviewDialog.vue?vue&type=style&index=0&id=871898a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871898a4",
  null
  
)

export default component.exports